import PropTypes, { string, number } from 'prop-types';
import { DownloadOutlined } from '@ant-design/icons';
import { Modal, Form, QRCode, Button } from 'antd';
import QR from 'assets/images/logo_simac_qr.png';

let idTextQR = '';
let idActa;
let idTipoActa;
let monitoringModel = {
  folio: '',
  idMonitoreo: number,
  idEstado: number,
  codigoMonitoreo: 1,
  idProcesoGeneral: number,
  descProcesoGral: '',
  idTipoEleccion: number,
  idAmbito: number,
  idTipoMonitoreo: number,
  estatus: number,
  estatusSincronizado: 1,
  tipoRegistro: number,
  fechaRegistro: number,
  usuario: '',
  tipoVisita: null
};

function ModalVistaQR({ open, callback, dataActa, actaType }) {
  if (!dataActa) {
    return null;
  }
  // console.log('QR data', dataActa);

  idTipoActa = actaType;
  // dataActaQR busca en actas el valor que coincide con acta de inicio
  const dataActaQR = dataActa.actas.find((e) => e.idTipoActa === idTipoActa);

  // console.log('dataActaQR', dataActaQR);
  // Sabemos que las actas de espectadulares tienen tipoActa 1, 2 y 3, mientras que visitas 6 y 7.
  if (actaType < 4) {
    idTextQR = 'ID acta: ';
  } else {
    idTextQR = 'ID visita: ';
  }

  idActa = dataActaQR ? dataActaQR?.idActa : dataActa?.visitas?.[0]?.idVisita;

  /* Modelo que envía a solicitud de SIMAC-Móvil
   * Éste modelo se pasa a QRCode en el value
   */
  monitoringModel = {
    folio: dataActa?.folio,
    idMonitoreo: dataActa?.idMonitoreo,
    idEstado: actaType < 4 ? dataActa?.idEstado : null,
    codigoMonitoreo: 1,
    idProcesoGeneral: dataActa?.idProcesoGral,
    descProcesoGral: dataActa?.descripcionProcesoGral,
    idTipoEleccion: dataActa?.idTipoEleccion,
    idAmbito: dataActa?.idAmbito,
    idTipoMonitoreo: dataActa.idTipoMonitoreo,
    estatus: actaType > 3 ? dataActa?.estatusMonitoreoId : dataActa?.estatusMonitoreo,
    estatusSincronizado: 1,
    tipoRegistro: dataActa?.tipoRegistro,
    fechaRegistro: dataActaQR ? dataActaQR?.fechaApertura : dataActa?.visitas?.[0]?.fechaApertura,
    usuario: dataActa?.usuarioRegistro,
    tipoVisita: actaType > 3 ? dataActa?.visitas?.[0]?.tipoVisita : null
  };
  // console.log('monitoringModel', monitoringModel);

  const handleCancel = () => {
    callback(false);
  };
  const handleDownload = () => {
    const canvas = document.getElementById('qr-canvas')?.querySelector('canvas');
    if (canvas) {
      const url = canvas.toDataURL();
      const a = document.createElement('a');
      a.download = `QR-SIMAC-${actaType}-${monitoringModel.idMonitoreo}.png`;
      a.href = url;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  };
  return (
    <Modal footer={null} width="37%" open={open} onCancel={handleCancel} centered>
      <Form name="form-QR" layout="vertical">
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: '10px'
          }}>
          <div
            id="qr-canvas"
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              padding: '20px'
            }}>
            <QRCode
              value={`
              {"folio": "${monitoringModel.folio}",
                "idMonitoreo": ${monitoringModel.idMonitoreo},
                "idEstado": ${monitoringModel.idEstado},
                "codigoMonitoreo": "${monitoringModel.codigoMonitoreo}",
                "idProcesoGeneral": ${monitoringModel.idProcesoGeneral},
                "descProcesoGral": "${monitoringModel.descProcesoGral}",
                "idTipoEleccion": ${monitoringModel.idTipoEleccion},
                "idAmbito": ${monitoringModel.idAmbito},
                "idTipoMonitoreo": ${monitoringModel.idTipoMonitoreo},
                "estatus": ${monitoringModel.estatus},
                "estatusSincronizado": ${monitoringModel.estatusSincronizado},
                "tipoRegistro": ${monitoringModel.tipoRegistro},
                "fechaRegistro": "${monitoringModel.fechaRegistro}",
                "usuario": "${monitoringModel.usuario}",
                "tipoVisita": ${monitoringModel.tipoVisita}}`}
              size={380}
              errorLevel="L"
              color="#D5157E"
              bgColor="white"
              bordered
              icon={QR}
            />
            <div style={{ paddingTop: '25px', paddingBottom: '5px' }}>
              <span style={{ fontWeight: 'bold', color: '#A4A2A2', fontSize: '20px' }}>
                {idTextQR}
              </span>
              <span style={{ color: '#C6C6C6', fontSize: '20px' }}>&nbsp; {idActa}</span>
            </div>
            <div style={{ padding: '10px' }}>
              <span style={{ fontWeight: 'bold', color: '#A4A2A2', fontSize: '20px' }}>
                Folio de Monitoreo:
              </span>
              <span style={{ color: '#C6C6C6', fontSize: '20px' }}>
                &nbsp; {monitoringModel.folio}
              </span>
            </div>
            <Button type="primary" style={{ marginTop: '10px' }} onClick={handleDownload}>
              <DownloadOutlined /> Descargar
            </Button>
          </div>
        </div>
      </Form>
    </Modal>
  );
}

export default ModalVistaQR;

ModalVistaQR.propTypes = {
  open: PropTypes.bool.isRequired,
  callback: PropTypes.func.isRequired,
  dataActa: PropTypes.arrayOf({
    folio: string,
    idMonitoreo: number,
    idEstado: number,
    idProcesoGral: number,
    descripcionProcesoGral: string,
    idTipoEleccion: number,
    idAmbito: number,
    idTipoMonitoreo: number,
    estatusMonitoreoId: number,
    tipoRegistro: number,
    fechaApertura: string,
    usuarioRegistro: string
  }).isRequired,
  actaType: PropTypes.number.isRequired
};
